import React from 'react';
import clsx from 'clsx';

export default function AppButton({
  children,
  onClick,
  width = 'w-16',
  roundedFull = 'rounded-full', // full Tailwind class
  className = '',
  disabled = false,
  ...props
}) {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={clsx(
        'flex items-center justify-center gap-1 p-2 text-onSecondaryContainer text-sm transition',
        width,
        roundedFull,
        disabled
          ? 'bg-gray-300 cursor-not-allowed text-gray-500'
          : 'bg-secondaryContainer hover:bg-secondary hover:text-onSecondary',
        className
      )}
      {...props}
    >
      {children}
    </button>
  );
}
